if (!HTMLFormElement.prototype.requestSubmit) {
  HTMLFormElement.prototype.requestSubmit = function (submitter) {
    if (submitter) {
      // Type assertion here
      const submitElement = submitter as HTMLInputElement;

      if (
        !(submitElement instanceof HTMLElement) ||
        submitElement.type !== 'submit' ||
        submitElement.form !== this
      ) {
        throw new DOMException('InvalidStateError');
      }
      submitElement.click();
    } else {
      const fakeSubmitter = document.createElement('button');
      fakeSubmitter.type = 'submit';
      fakeSubmitter.style.display = 'none';
      this.appendChild(fakeSubmitter);
      fakeSubmitter.click();
      this.removeChild(fakeSubmitter);
    }
  };
}
